import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

let firebase = require('firebase');

const firebaseConfig = {
  apiKey: "AIzaSyCXi_GWJ2HHHpmozafSyOTOQHbDnSjoPSQ",
  authDomain: "sarathi-c95a5.firebaseapp.com",
  databaseURL: "https://sarathi-c95a5.firebaseio.com",
  projectId: "sarathi-c95a5",
  storageBucket: "sarathi-c95a5.appspot.com",
  messagingSenderId: "902305184130",
  appId: "1:902305184130:web:26bd3a060f693b7dc7f79b"
}
firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
